export default "__VITE_ASSET__DzH8$6MY__"